module.exports = __webpack_public_path__ + "static/media/galerija_2017 (42).058e0ac7.jpg";